import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface FooterLink {
  to: string;
  label: string;
  requireAuth?: boolean;
  hideWhenGuest?: boolean;
}

const COLUMNS: { title: string; links: FooterLink[] }[] = [
  {
    title: '产品',
    links: [
      { to: '/leads', label: '发现线索' },
      { to: '/coming-soon/thinktank', label: '行业智库' },
      { to: '/', label: '深入分析' },
      { to: '/coming-soon/bp', label: '税务合规BP工作台' },
      { to: '/coming-soon/boss', label: 'BOSS经营智能体' },
      { to: '/coming-soon/orders', label: '价格与权益' },
    ],
  },
  {
    title: '我的工作台',
    links: [
      { to: '/my-analysis', label: '我的分析', requireAuth: true },
      { to: '/my/favorites', label: '我的收藏', requireAuth: true },
      { to: '/my/clients', label: '我的客户', requireAuth: true },
      { to: '/coming-soon/reports', label: '我的报告', requireAuth: true, hideWhenGuest: true },
      { to: '/coming-soon/orders', label: '订单与权益', requireAuth: true },
    ],
  },
  {
    title: '数据与说明',
    links: [
      { to: '/coming-soon/settings', label: '账号设置', requireAuth: true },
      { to: '/leads', label: '潜在线索池' },
    ],
  },
];

/** 对照 demo SiteFooter */
export default function Footer() {
  const navigate = useNavigate();
  const { user, requestLogin } = useAuth();
  const isLoggedIn = Boolean(user);

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-shield-flash-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                税务洞察 TaxInsight
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              从企业数据发现服务机会，让每条线索都有依据、每项服务都有路径。为涉税服务机构与企业老板提供从线索发现到合规交付的一体化能力。
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => {
                  if (link.hideWhenGuest && !isLoggedIn) return null;
                  return (
                    <li key={`${col.title}-${link.to}-${link.label}`}>
                      {link.requireAuth && !isLoggedIn ? (
                        <button
                          type="button"
                          onClick={() => requestLogin(() => navigate(link.to))}
                          className="cursor-pointer text-sm text-background-200/80 transition-colors hover:text-background-50"
                        >
                          {link.label}
                        </button>
                      ) : (
                        <Link
                          to={link.to}
                          className="text-sm text-background-200/80 transition-colors hover:text-background-50"
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-background-100/10 pt-6 text-xs text-background-200/60">
          <span>© {new Date().getFullYear()} 成都旗峰顺世科技股份有限公司</span>
        </div>
      </div>
    </footer>
  );
}
